import { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { Link } from "react-router-dom";
import { fmtMoney } from "../lib/api";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const icon = new L.Icon({
  iconUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

const priceOf = (p) => p.sale_price || p.monthly_rent || p.event_price_per_day || 0;

function MapReady({ onReady }) {
  const map = useMap();
  useEffect(() => { onReady && onReady(map); }, [map, onReady]);
  return null;
}

export const PropertyMap = ({ properties = [], height = 420, center, zoom = 6, single = false,
                              showAreaSearch = false, onAreaSearch, onReset, areaActive = false, onMapReady }) => {
  const pts = properties.filter((p) => p.latitude && p.longitude);
  const defaultCenter = center || (pts[0] ? [pts[0].latitude, pts[0].longitude] : [12.5, -6.5]);
  const mapRef = useRef(null);

  return (
    <div className="relative rounded-2xl overflow-hidden border border-stone-200" style={{ height }} data-testid="property-map">
      {showAreaSearch && (
        <div className="absolute top-3 right-3 z-[1000] flex gap-2">
          {areaActive && (
            <button data-testid="map-reset-area" onClick={() => onReset && onReset()}
              className="bg-white text-stone-700 text-xs font-semibold px-3 py-2 rounded-full shadow-md border border-stone-200 hover:bg-stone-50">
              Tout afficher
            </button>
          )}
          <button data-testid="map-search-area" onClick={() => mapRef.current && onAreaSearch && onAreaSearch(mapRef.current.getBounds())}
            className="bg-orange-800 text-white text-xs font-semibold px-3 py-2 rounded-full shadow-md hover:bg-orange-900">
            Rechercher dans cette zone
          </button>
        </div>
      )}
      <MapContainer center={defaultCenter} zoom={single ? 13 : zoom} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <MapReady onReady={(m) => { mapRef.current = m; onMapReady && onMapReady(m); }} />
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; OpenStreetMap' />
        {pts.map((p) => (
          <Marker key={p.id} position={[p.latitude, p.longitude]} icon={icon}>
            <Popup>
              <div className="min-w-[160px]">
                <img src={p.media?.[0] || "https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=200&q=70"} alt="" className="w-full h-20 object-cover rounded mb-1" />
                <div className="font-semibold text-sm">{p.title}</div>
                <div className="text-orange-800 font-bold text-sm">{fmtMoney(priceOf(p))}</div>
                {!single && <Link to={`/property/${p.id}`} className="text-xs text-orange-800 underline">Voir le bien</Link>}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};
